<template>
  <div id="errors" v-if="show()">
    <p v-for="(error, index) in errors" :key="index" class="errorMessages mb-2">
      {{ error.message || error }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ErrorsMessages",
  props: {
    errors: Array,
  },
  methods: {
    show() {
      if (this.errors.length > 0) {
        this.goToErrors();
        return true;
      }

      return false;
    },
    goToErrors() {
      setTimeout(() => {
        var modal = document.getElementById("errors");
        modal.scrollIntoView({ block: "start", behavior: "smooth" });
      }, 10);
    },
  },
};
</script>

<style>
.errorMessages {
  background-color: #f8d7da !important;
  padding: 5px 10px !important;
  border-radius: 4px;
  color: #58151c !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
}
</style>